import { Absolute } from '../bases/Absolute'
import { HStack } from '../bases/HStack'
import { Text } from '../bases/Text'
import { CardSize } from '../nft/common/CardFrame'

// MegaSparkingの回数分母
const FEVER_SPARK_REMAIN_DENOMINATOR = 30

const megaSparkingStyles = {
  S: { fontSize: 10 },
  M: { fontSize: 18 },
  L: { fontSize: 18 },
}

const parentFeverSparkRemainStyles = {
  S: 'items-center',
  M: 'items-end',
  L: 'items-end',
}

const feverSparkRemainStyles = {
  S: { fontSize: 10 },
  M: { fontSize: 24 },
  L: { fontSize: 24 },
}

const denominatorStyles = {
  S: { fontSize: 10 },
  M: { fontSize: 16, marginBottom: 2 },
  L: { fontSize: 16, marginBottom: 2 },
}

export const MegaSparkingLabel = (props: {
  feverSparkRemain: number
  className?: string
  cardSize: CardSize
}) => {
  const isMegaSparking = props.feverSparkRemain > 0
  return (
    <Absolute className={`w-full ${props.className}`}>
      <HStack className="w-full items-center justify-center gap-x-1">
        <Text
          className={`rounded-lg px-2 font-bold ${isMegaSparking ? 'text-white' : 'text-white/60'}`}
          style={{
            textShadow: isMegaSparking ? '0px 0px 10px #FFF' : '',
            background: isMegaSparking
              ? 'linear-gradient(92deg, rgba(241, 167, 56, 0.80) 0.11%, rgba(237, 241, 56, 0.80) 100%)'
              : '#212226',
            ...megaSparkingStyles[props.cardSize],
          }}
        >
          MEGA SPARKING
        </Text>
        <HStack
          className={`items-end justify-center rounded-md bg-black/70 px-1 ${
            parentFeverSparkRemainStyles[props.cardSize]
          }`}
        >
          <Text
            className={`font-bold ${isMegaSparking ? 'text-akiverse-yellow' : 'text-[#DC325B]'}`}
            style={feverSparkRemainStyles[props.cardSize]}
          >
            {props.feverSparkRemain}
          </Text>
          <Text className="text-base font-bold text-white" style={denominatorStyles[props.cardSize]}>
            /{FEVER_SPARK_REMAIN_DENOMINATOR}
          </Text>
        </HStack>
      </HStack>
    </Absolute>
  )
}
